/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'hamburger': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M20 8H4a1 1 0 010-2h16a1 1 0 010 2zM20 13H4a1 1 0 010-2h16a1 1 0 010 2zM20 18H4a1 1 0 010-2h16a1 1 0 010 2z"/>'
  }
})
